import styled, { css } from 'styled-components'

export const Container = styled.div`
    width: 20rem;
    margin: 0 auto 2rem auto;

    .countryAndCheckbox{
        display: flex;
        align-items: center; 
        margin-top: 1rem;
        width: 100%;
        position: relative;
    }
`

export const CountryContent = styled.div`
    padding: 0.5rem 1rem;
    flex: auto;

    border: 3px solid #393939;
    border-radius: 5px;

    display: flex;
    align-items: center;
    font-size: 1.5rem;

    img{
        height: 4rem;
        margin-right: 2rem;
    }

    
    @media (min-width: 960px){
        cursor: pointer;
    }
`

export const RegionsContainer = styled.div`
    overflow: hidden;
    transition: all 0.2s;
    width: 100%;
    
    ${props => props.heightCountryRegions && css`
        max-height: ${props.heightCountryRegions};
    `}
`

